import { DropzoneBox, SIMDocumentTypeAttachmentOption } from 'common';

/** Mirrors the backend's allowed attachment extensions (Constants.AttachmentFileType). */
const ACCEPTED_FILE_TYPES = ['.pdf', '.doc', '.docx', '.tif', '.tiff', '.xls', '.xlsx', '.xml'];

const MAX_NUMBER_OF_FILES = 5;

const MISSING_REQUIRED_MESSAGE = 'At least one supporting document is required.';

export interface SimAttachmentsDropzoneProps {
    attachmentOption: SIMDocumentTypeAttachmentOption;
    files: File[];
    onFilesChange: (files: File[]) => void;
    testId: string;
    /** Set when Next was blocked because a Required schedule had no files. */
    hasError?: boolean;
}

/** Supporting-document dropzone for a SIM step; hidden when the buyer's schedule disallows attachments. */
export function SimAttachmentsDropzone({
    attachmentOption,
    files,
    onFilesChange,
    testId,
    hasError = false,
}: SimAttachmentsDropzoneProps) {
    if (attachmentOption === SIMDocumentTypeAttachmentOption.NoAttachments) {
        return null;
    }

    const isRequired = attachmentOption === SIMDocumentTypeAttachmentOption.Required;

    return (
        <DropzoneBox
            label={isRequired ? 'Supporting documents' : 'Supporting documents (optional)'}
            required={isRequired}
            error={hasError}
            errorText={MISSING_REQUIRED_MESSAGE}
            maxNumberOfFiles={MAX_NUMBER_OF_FILES}
            setAcceptedFiles={onFilesChange}
            initialFiles={files}
            acceptedFileTypes={ACCEPTED_FILE_TYPES}
            testId={testId}
        />
    );
}
